export const ERROR_CODE_UNKNOWN = -1
export const ERROR_CODE_REFRESH = 102
export const ERROR_CODE_NETWORK_ERROR = 500

export const NMH_SUBDOMAIN = 'nmh.dev'
